import { render, staticRenderFns } from "./DoctorSelectPage.vue?vue&type=template&id=26fd32ce&scoped=true"
import script from "./DoctorSelectPage.vue?vue&type=script&lang=js"
export * from "./DoctorSelectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fd32ce",
  null
  
)

export default component.exports